/**
 * @file
 * Behaviors for the side navigation.
 */
/* eslint-disable max-len */

(function (Drupal) {
  /**
   * Setup and attach the Popover behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.dropdown = {
    attach: function () {
      executeOnce('SidebarNav', function () {
        const title = document.querySelectorAll('.navigation--title-wrapper');
        const sub_title = document.querySelectorAll('.navigation--links');

        Array.from(title).forEach(function (title) {
          title.addEventListener('click', function () {
            const btn = this.nextElementSibling;
            if (btn != null) {
              const icon = this.querySelector('.material-symbols-outlined');
              btn.classList.toggle('d-flex');
              if (icon.innerHTML === 'expand_more') {
                icon.innerHTML = 'expand_less';
              }
              else {
                icon.innerHTML = 'expand_more';
              }
            }
          });
        });

        if (sub_title != null) {
          Array.from(sub_title).forEach(function (sub_title) {
            sub_title.addEventListener('click', function () {
              const btn = this.nextElementSibling;
              if (btn != null) {
                const icon = this.querySelector('.material-symbols-outlined');
                btn.classList.toggle('d-block');
                if (icon.innerHTML === 'expand_more') {
                  icon.innerHTML = 'expand_less';
                }
                else {
                  icon.innerHTML = 'expand_more';
                }
              }
            });
          });
        }
      });
    }
  };
})(Drupal);
